<div class="relative" [ngStyle]="{'max-width': size + 'px'}">
  <div *ngIf="avatarUrl"
       [ngClass]="['avatar-container', className]"
       [ngStyle]="style">
  </div>

  <div *ngIf="status">
    <div class="absolute status">{{ statuses[status]?.emoji }}</div>
  </div>

  <nz-avatar
    *ngIf="!avatarUrl && text"
    [nzSize]="size"
    [nzShape]="'square'"
    nzText="{{ text | avatarLetters }}"
    style="color:#ffffff; background-color:#7e22ce;"
    class="{{ className }}">
  </nz-avatar>
</div>
